<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{name:'index'}">首页</router-link>>
          企业入驻
        </div>
        <div class="intro-business-wrap">
          <div class="title">
            <h2>企业入驻</h2>
            <div class="content_text">
              <p>幸福上班族是上班族平台发起并组建的企业联盟。依托于上班族平台的会员制电商服务，幸福上班族帮助会员企业打造企业内部的特卖场、生日场、节日场等。管理员通过后台操作，实现商品选择、活动板块定制、设置活动专区、员工参与条件、企业文化的展现等内容提升员工归属感、幸福感。为企业留住更多人才的同时，省时、省力、省心、省钱的做好企业福利工作。</p>
              <p>企业可通过以下两种途径加入幸福上班族：</p>
              <p>1.联系客服: 400-088-8635（工作日周一至周五9:00-18:00）</p>
              <p>2.发送邮件至kefu@shangbanzu.gift 收到申请后我们会有相关工作人员与您联系，请保持通信畅通，谢谢。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.intro-business-wrap{
  margin-bottom: 40px;
  height: 572px;
  box-sizing: border-box;
  padding: 10px 25px 0;
  background-color: #fff;
  .title {
    line-height: 42px;
    height: 42px;
    border-bottom: 2px solid #dadada;
    margin-bottom: 30px;
    h2 {
      display: inline-block;
      border-bottom: 2px solid #e2333f;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      box-sizing: border-box;
      padding: 0 20px;
    }
  }
  .content_text {
    padding: 0 20px;
    font-size: 16px;
    line-height: 36px;
    color: #222;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/introduce/business.vue